import { Button } from "antd";
import { useEffect, useState } from "react";
import { GrDocumentPdf } from "react-icons/gr";
import { pdfStore } from "src/stores/pdf-store";
import { profileStore } from "src/stores/profile-store";
import { componentPalette } from "src/theme/component-palette";
import { blob } from "src/utils/http-common";
import { capitalizeFirstLetter } from "src/utils/manage-string";
import { useShallow } from "zustand/react/shallow";

const Pdf = (props: { path: string }) => {
  const { path } = props;
  const profile = profileStore(useShallow((state) => state.profile));
  const companyName = profile?.activeCompany?.companyName;
  const queryStr = pdfStore(useShallow((state) => state.filter));
  const [urlAPI, setUrlApi] = useState<string>("");
  const [fileName, setFileName] = useState<string>("test.pdf");
  const [loading, setLoading] = useState(false);

  const exportPdf = async () => {
    setLoading(true);
    await blob.get(urlAPI, { params: queryStr }).then((response) => {
      const link: any = document.createElement("a");
      link.href = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
      link.download = fileName;
      document.body.appendChild(link);

      link.click();
      setTimeout(function () {
        window.URL.revokeObjectURL(link);
      }, 200);
    });
    setLoading(false);
  };

  useEffect(() => {
    if (path === "/vocs-inventory/flare/report-government") {
      const suffixFileName = `${!queryStr?.month || !queryStr?.year ? "" : `-${capitalizeFirstLetter(queryStr?.month)}-${queryStr?.year}`}`;
      setFileName(`${companyName}-รายงานราชการ${suffixFileName}`);
      setUrlApi(`/api/flare/report/government/export-pdf`);
    }
  }, [path, queryStr]);

  return (
    <div>
      <Button
        loading={loading}
        type="text"
        icon={<GrDocumentPdf style={{ fontSize: "28px", color: componentPalette.redThird }} onClick={exportPdf} />}
      />
    </div>
  );
};

export default Pdf;
